<style scoped>
.align-top-right{
  top: -8px;
  right: -2px;
}
.filename{
  width: 366px;
  padding-top: 30px;
  height: 100px;
}
.filename strong{
  display: block;
  overflow: hidden;
  height: 25px;
}
</style>

<template>
  <v-card
    class="text-center"
  >

    <v-img
      :src="previewUrl"
      min-height="125"
      max-height="125"
      contain
      class="grey darken-4"
    />

    <v-overlay
      absolute
      color="#036358"
    >

      <div
        class="filename"
        v-cloak @drop.prevent="(e) => $emit('addDropFile', e)" @dragover.prevent
        @click="() => $emit('triggerFileInput')"
      >
        <strong>{{ filename }}</strong>
        ------- <br>
        <div>Drag and drop or click to replace</div><br>
      </div>
      <v-btn
        absolute
        z-index=9
        small
        outlined
        class="align-top-right"
        @click="() => $emit('confirm')"
      >
        Remove
      </v-btn>

    </v-overlay>
  </v-card>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

export default {
  props: {
    user: Object,
    previewUrl: String,
    filename: String,
  },
};
</script>
